module.exports = { id: "steer", url: "/build/app/img/symbols.svg#steer", viewBox: "", toString: function() { return this.url; } };